import type { BlockSortKey } from "./blockSort";

export function BlockSortSelect({ value, onChange }: { value: BlockSortKey; onChange: (key: BlockSortKey) => void }) {
  return (
    <label>
      Sort
      <select value={value} onChange={(event) => onChange(event.target.value as BlockSortKey)}>
        <option value="size">Size</option>
        <option value="due">Due date</option>
      </select>
    </label>
  );
}
